import { Locale } from "next/router";
import { BRAND_OVERVIEW_LOCALIZED_BASE_PATH_MAP } from "@/common/static/brands.static";

export const getBrandOverviewLocalizedPath = (locale: Locale) => {
  return BRAND_OVERVIEW_LOCALIZED_BASE_PATH_MAP[locale];
};
